export default "__VITE_ASSET__CtDZQ5f6__"